<template>
	<page-container class="container container-index" :page="page">
		<div v-if="page.headingImages" class="hero-wrapper">
			<div v-if="defaults[locale].homepage.embedCodeHomepage" class="video-foreground">
				<div>
					<iframe
						:src="`${defaults[locale].homepage.embedCodeHomepage}?loop=1&muted=1&badge=0&autoplay=1&controls=0&autopause=0&player_id=0`"
						frameborder="0"
						allow="autoplay; fullscreen; picture-in-picture"
						allowfullscreen
						title="Metzlr House video"
					/>
				</div>
			</div>
			<heading-image
				v-for="(item, index) in page.headingImages"
				:key="index"
				:heading-image="item"
				type="large"
				:title="page.title || page.header"
			/>
		</div>

		<main-content :subtitle="page.subtitle" :content="page.content" />
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

useHead({
	bodyAttrs: {
		class: 'index',
	},
});
</script>

<style lang="scss" scoped>
.hero-wrapper {
	position: relative;
	height: 100vh;
	width: 100%;
	overflow: hidden;
}

.video-foreground {
	position: absolute;
	top: 0;
	left: -150%;
	width: 400%;
	height: 130%;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 2;
	}
}

@media (max-width: 1080px) {
	.video-foreground {
		height: 100%;
	}
}

@media (max-width: 500px) {
	.video-foreground {
		width: 470%;
	}
}
</style>
